<template>
	<v-sheet rounded class="mb-4">
		<v-form @submit.prevent="form.put(route('settings.update'))">
			<v-card color="#125B92" elevation="0" class="rounded-b-0">
				<v-card-title class="align-center">
					<h3 class="white--text">Billing Settings</h3>
					<v-spacer />
				</v-card-title>
				<v-divider />
				<v-card-text class="white">
					<div class="mt-2">
						<v-row>
							<v-col>
								<p>This information used on Invoices and generated PDFs. Changes made here will impact all invoices (past and future).</p>
								<v-divider class="mb-1" />
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="form.billing_name"
									label="Billing Name"
									name="billing_name"
									:hide-details="! hasErrors(form, 'billing_name')"
									:error="hasErrors(form, 'billing_name')"
									:error-messages="errorMsg(form, 'billing_name')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
							<v-col>
								<v-text-field
									v-model="form.billing_tax_id"
									label="Billing Tax ID"
									name="billing_tax_id"
									:hide-details="! hasErrors(form, 'billing_tax_id')"
									:error="hasErrors(form, 'billing_tax_id')"
									:error-messages="errorMsg(form, 'billing_tax_id')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="form.billing_address1"
									label="Billing Address Line 1"
									name="billing_address1"
									:hide-details="! hasErrors(form, 'billing_address1')"
									:error="hasErrors(form, 'billing_address1')"
									:error-messages="errorMsg(form, 'billing_address1')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="form.billing_address2"
									label="Billing Address Line 2"
									name="billing_address2"
									:hide-details="! hasErrors(form, 'billing_address2')"
									:error="hasErrors(form, 'billing_address2')"
									:error-messages="errorMsg(form, 'billing_address2')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4">
								<v-text-field
									v-model="form.billing_city"
									label="Billing City"
									name="billing_city"
									:hide-details="! hasErrors(form, 'billing_city')"
									:error="hasErrors(form, 'billing_city')"
									:error-messages="errorMsg(form, 'billing_city')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
							<v-col cols="12" md="4">
								<v-select v-if="states"
									v-model="form.billing_state_id"
									:items="states"
									:error="hasErrors(form, 'billing_state_id')"
									:error-messages="errorMsg(form, 'billing_state_id')"
									persistent-placeholder
									item-text="code"
									item-value="id"
									label="Select State"
									outlined
									dense />
							</v-col>
							<v-col cols="12" md="4">
								<v-text-field
									v-model="form.billing_zipcode"
									label="Billing Zip Code"
									name="billing_zipcode"
									:hide-details="! hasErrors(form, 'billing_zipcode')"
									:error="hasErrors(form, 'billing_zipcode')"
									:error-messages="errorMsg(form, 'billing_zipcode')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
						</v-row>
						<v-row>
							<v-col><v-divider /></v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="form.billing_phone"
									label="Billing Phone Number"
									name="billing_phone"
									:hide-details="! hasErrors(form, 'billing_phone')"
									:error="hasErrors(form, 'billing_phone')"
									:error-messages="errorMsg(form, 'billing_phone')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
							<v-col>
								<v-text-field
									v-model="form.billing_phone_2"
									label="Billing Phone #2"
									name="billing_phone_2"
									:hide-details="! hasErrors(form, 'billing_phone_2')"
									:error="hasErrors(form, 'billing_phone_2')"
									:error-messages="errorMsg(form, 'billing_phone_2')"
									persistent-placeholder
									outlined
									dense />
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="form.billing_email"
									label="Billing Email Address"
									name="billing_email"
									type="email"
									:hide-details="! hasErrors(form, 'billing_email')"
									:error="hasErrors(form, 'billing_email')"
									:error-messages="errorMsg(form, 'billing_email')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
						</v-row>
						<v-row>
							<v-col><v-divider /></v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="form.billing_wiring_label"
									label="Billing Wiring Label"
									name="billing_wiring_label"
									type="email"
									:hide-details="! hasErrors(form, 'billing_wiring_label')"
									:error="hasErrors(form, 'billing_wiring_label')"
									:error-messages="errorMsg(form, 'billing_wiring_label')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" sm="4">
								<v-text-field
									v-model.trim="form.billing_account_number"
									label="Billing Account Number"
									name="billing_account_number"
									:hide-details="! hasErrors(form, 'billing_account_number')"
									:error="hasErrors(form, 'billing_account_number')"
									:error-messages="errorMsg(form, 'billing_account_number')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
							<v-col cols="12" sm="4">
								<v-text-field
									v-model.trim="form.billing_wiring_number"
									label="Billing Wiring Number"
									name="billing_wiring_number"
									:hide-details="! hasErrors(form, 'billing_wiring_number')"
									:error="hasErrors(form, 'billing_wiring_number')"
									:error-messages="errorMsg(form, 'billing_wiring_number')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
							<v-col cols="12" sm="4">
								<v-text-field
									v-model.trim="form.billing_ach_number"
									label="Billing ACH Number"
									name="billing_ach_number"
									:hide-details="! hasErrors(form, 'billing_ach_number')"
									:error="hasErrors(form, 'billing_ach_number')"
									:error-messages="errorMsg(form, 'billing_ach_number')"
									persistent-placeholder
									outlined
									required
									dense />
							</v-col>
						</v-row>
					</div>
				</v-card-text>
				<v-divider class="grey lighten-2" />
				<v-card-actions class="white pa-5">
					<v-btn large color="success" type="submit">Save Changes</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-sheet>
</template>
<script>
import states from '@/Mixins/states'

export default {
	mixins: [ states ],
	props: {
		//
	},
	data () {
		return {
			form: this.$inertia.form({
				billing_name: null,
				billing_tax_id: null,
				billing_address1: null,
				billing_address2: null,
				billing_city: null,
				billing_state_id: null,
				billing_zipcode: null,
				billing_phone: null,
				billing_phone_2: null,
				billing_email: null,
				billing_wiring_label: null,
				billing_account_number: null,
				billing_wiring_number: null,
				billing_ach_number: null
			}),
			settings: this.$page.props.settings
		}
	},
	mounted () {
		this.populateForm()
	},
	methods: {
		populateForm () {
			if (this.settings) {
				for (const settingKey in this.settings) {
					if (!this.settings.hasOwnProperty(settingKey)) continue
					if (!this.form.hasOwnProperty(settingKey)) continue

					this.form[settingKey] = this.settings[settingKey]
				}
			}
		}
	}
}
</script>
